// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"e4ae80ac","297":"b65849be","727":"73eae202","908":"14c6c3ea"}[chunkId] + ".chunk.css";
};